import React, { ReactElement } from 'react';

export default function RuralResidential(props: {
    className?: string;
}): ReactElement {
    const { className } = props;

    return (
        <svg className={className} fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
            <path d='M17.3777 7.56182C20.0886 7.56182 20.8187 10.3819 18.997 11.8859C21.2235 17.1499 15.1512 19.406 12.3278 16.3703C11.7102 19.7819 6.0427 19.9699 5.92327 16.3703C1.38733 15.2699 2.6018 10.0058 6.3502 9.47628C4.64226 7.44863 6.32392 2.88467 9.76623 2.17662C14.9488 1.11061 17.985 5.1178 17.3777 7.56182Z' fill='white' stroke='currentColor' strokeLinecap='round' />
            <path d='M12 22V14M12 9V14M12 12L14 10M12 14L10 12.5' stroke='currentColor' strokeLinecap='round' />
        </svg>
    );
}